import React, { useEffect, useReducer } from "react";
import swal from "sweetalert";
import Api from "./Api";
const initialState = {
    data: [],
    IsLoading: true,
    error: ""
};
const reducer = (state, action) => {
    switch (action.type) {
        case "FETCH_SUCCESS":
            return {
                IsLoading: false,
                data: action.payload,
                error: ""
            };
        case "FETCH_ERROR":
            return {
                IsLoading: false,
                data: [],
                error: action.payload
            };
        default:
            return state;
    }
};
const useGetData = (url) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const FetchAll = () => {

        Api.get(url)
            .then(response => {
                if (response.status == 200) {
                    dispatch({ type: "FETCH_SUCCESS", payload: response.data });
                } else if (response.status == 401 || response.status == 403) {
                    dispatch({ type: "FETCH_ERROR", payload: "Access denied." });
                    swal("Access denied.")
                } else {
                    dispatch({ type: "FETCH_ERROR", payload: "Request failed" });
                    swal("Request failed.")
                }

            })
            .catch(function (error) {
                // handle error
                // setError(error);
            })
            .then(function () {
                // always executed
            })


    }

    return [state, FetchAll];
};

export default useGetData;